import { render, staticRenderFns } from "./ReservationPeriod.vue?vue&type=template&id=82b6d62e&"
import script from "./ReservationPeriod.vue?vue&type=script&lang=js&"
export * from "./ReservationPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports